import type { TranslationInterface } from '.';

export const VietnameseLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Viết tin nhắn...',
  your_issue_has_been_resolved: 'Vấn đề của bạn đã được giải quyết!',
  new_conversation: 'Cuộc trò chuyện mới',
  welcome_screen_title: 'Chào mừng đến với hỗ trợ trò chuyện của chúng tôi',
  welcome_screen_description:
    'Chúng tôi ở đây để giúp đỡ! Bắt đầu cuộc trò chuyện và chúng tôi sẽ phản hồi sớm nhất có thể.',
  your_name_placeholder: 'Tên của bạn',
  your_email_placeholder: 'Địa chỉ email của bạn',
  start_chat_button: 'Liên hệ hỗ trợ',
  start_chat_button_loading: 'Đang kết nối...',
  i_need_more_help: 'Tôi cần thêm trợ giúp',
  this_was_helpful: 'Điều này hữu ích',
  optional: 'Tùy chọn',
  no_conversations_yet: 'Chưa có cuộc trò chuyện nào',
  back_to_conversations: 'Quay lại cuộc trò chuyện',
  closed_conversations: 'Cuộc trò chuyện đã đóng',
  csat_title: 'Cuộc trò chuyện của bạn thế nào?',
  csat_submitted_title: 'Bạn đã đánh giá cuộc trò chuyện là',
  csat_feedback_placeholder: 'Cho chúng tôi biết thêm... (tùy chọn)',
  follow_up_placeholder: 'Hỏi thêm…',
  companion_layout_label: 'Bố cục',
  companion_layout_floating: 'Nổi',
  companion_layout_sidebar: 'Thanh bên',
  companion_layout_fullscreen: 'Toàn màn hình',
  companion_close: 'Đóng',
  companion_history: 'Lịch sử trò chuyện',
  companion_expand_chat: 'Mở rộng cuộc trò chuyện',
  companion_sidebar_dock_label: 'Ghim',
  companion_sidebar_side_label: 'Phía',
  companion_sidebar_left: 'Trái',
  companion_sidebar_right: 'Phải',
  companion_resize_chat: 'Đổi kích thước cuộc trò chuyện',
  scroll_to_bottom: 'Cuộn xuống dưới cùng',
  thinking: 'Đang suy nghĩ…',
  running: 'Đang chạy…',
  steps: 'bước',
  step_arguments: 'Đối số',
  step_result: 'Kết quả',
  attach_files:
    'Đính kèm hình ảnh, video, PDF hoặc bảng tính (kích thước tối đa 25 MB)',
  mark_page_active:
    'Nhấp vào bất kỳ nội dung nào trên trang để đánh dấu — nhấn Esc để hủy',
  mark_page: 'Đánh dấu nội dung trên trang để hỏi về nội dung đó',
  stop_response: 'Dừng trả lời',
  copy_reply: 'Sao chép câu trả lời',
  mentions_empty: 'Không có kết quả',
  copied: 'Đã sao chép',
  send_message: 'Gửi tin nhắn',
  upload_failed: 'Tải lên không thành công: {error}',
  remove_attachment: 'Xóa tệp đính kèm',
  json_no_items: 'Không có mục nào',
  json_no_data: 'Không có dữ liệu',
  json_no_chart_data: 'Không có dữ liệu cho biểu đồ',
  json_unsupported: 'Không được hỗ trợ: {type}',
  json_see_less: 'Hiện ít hơn',
  json_phone_agent: 'Tổng đài viên',
  json_phone_agent_test: 'Thử qua web',
  page_context_remove: 'Xóa ngữ cảnh trang',
  json_see_more: 'Hiện thêm {count}',
  queued_label: '{count} Đang chờ',
  remove_queued_message: 'Xóa tin nhắn khỏi hàng đợi',
  send_queued_now: 'Gửi tin nhắn trong hàng đợi ngay',
  turn_failed_message: 'Đã xảy ra lỗi và không nhận được câu trả lời.',
  turn_failed_retry: 'Thử lại',
  page_mark_hint: 'Nhấp vào nội dung bất kỳ để đánh dấu',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Khung',
  page_mark_shape_circle: 'Hình tròn',
  page_mark_shape_arrow: 'Mũi tên',
  page_mark_shape_bracket: 'Ngoặc',
  page_mark_shape_underline: 'Gạch chân',
  page_mark_shape_highlight: 'Tô sáng',
  page_mark_shape_strike_through: 'Gạch ngang',
  page_mark_shape_crossed_off: 'Gạch chéo',
  page_mark_shape_aria: 'Hình dạng dấu: {shape}',
  page_mark_note_placeholder: 'Thêm ghi chú… (Enter để đính kèm)',
  page_mark_attach: 'Đính kèm dấu',
  page_mark_remove: 'Xóa {label}',
  page_mark_region: 'Vùng đã đánh dấu',
  page_mark_default_message: 'Đây là gì?',
  file_rejected: 'Loại tệp không được hỗ trợ hoặc tệp quá lớn.',
  dictate: 'Đọc để nhập',
  stop_dictation: 'Dừng đọc',
  dictation_mic_blocked: 'Cho phép truy cập micrô để đọc nhập',
  dictation_unavailable: 'Hiện không thể dùng tính năng đọc để nhập',
  questions_back: 'Quay lại',
  questions_next: 'Tiếp theo',
  questions_send: 'Gửi',
  questions_type_answer: 'Tôi sẽ tự nhập',
  questions_answer_placeholder: 'Nhập câu trả lời của bạn…',
  close_conversation_title: 'Đóng cuộc trò chuyện',
  close_conversation_description:
    'Bạn có chắc muốn đóng cuộc trò chuyện này không?',
  close_conversation_cancel: 'Không',
  close_conversation_confirm: 'Có',
  dialog_close: 'Đóng',
  zoom_in: 'Phóng to',
  zoom_out: 'Thu nhỏ',
  reset_zoom: 'Đặt lại thu phóng',
  support_chat_aria_label: 'Trò chuyện hỗ trợ',
};
